import { AxiosInstance, AxiosRequestConfig, AxiosResponse } from 'axios'

export class APIClient {
  axiosInstance: AxiosInstance
  refreshAccessToken: () => Promise<any>

  constructor(axiosInstance: AxiosInstance, refreshAccessToken: () => Promise<any>) {
    this.axiosInstance = axiosInstance
    this.refreshAccessToken = refreshAccessToken
  }

  async get<T = any, R = AxiosResponse<T>>(url: string, config?: AxiosRequestConfig): Promise<R> {
    await this.refreshAccessToken()
    return this.axiosInstance.get(url, config)
  }

  async post<T = any, R = AxiosResponse<T>>(
    url: string,
    data?: any,
    config?: AxiosRequestConfig
  ): Promise<R> {
    await this.refreshAccessToken()
    if (config?.data) {
      delete config.data
    }
    return this.axiosInstance.post(url, data, config)
  }

  async put<T = any, R = AxiosResponse<T>>(
    url: string,
    data?: any,
    config?: AxiosRequestConfig
  ): Promise<R> {
    await this.refreshAccessToken()
    if (config?.data) {
      delete config.data
    }
    return this.axiosInstance.put(url, data, config)
  }

  async patch<T = any, R = AxiosResponse<T>>(
    url: string,
    data?: any,
    config?: AxiosRequestConfig
  ): Promise<R> {
    await this.refreshAccessToken()
    if (config?.data) {
      delete config.data
    }
    return this.axiosInstance.patch(url, data, config)
  }

  async delete<T = any, R = AxiosResponse<T>>(url: string, config?: AxiosRequestConfig): Promise<R> {
    await this.refreshAccessToken()
    return this.axiosInstance.delete(url, config)
  }
}
